module.exports = __webpack_public_path__ + "img/laboratorio_16-9.0a28240d.webp";